import {ButtonAction} from '@dv5/components'
import {ItemAction} from '@dv5/domain'

export const menuItems: Array<ButtonAction> = [
    {
        action: ItemAction.MOVE_TO_LAYERS,
        text: 'Set layers'
    },
    {
        action: ItemAction.ASSIGN_TO_TAGS,
        text: 'Assign to tags'
    },
]

export const editMenuItems: Array<ButtonAction> = [
    {
        text: "Stop edit",
        action: ItemAction.EDIT
    },
    ...menuItems,
]

export const viewMenuItems: Array<ButtonAction> = [
    {
        text: "Start edit",
        action: ItemAction.EDIT
    },
    {
        text: 'Change content type...',
        action: ItemAction.CHANGE_PART_TYPE
    },
    ...menuItems,
    {
        action: ItemAction.MOVE_TO_DOCUMENT,
        text: 'Move to document...'
    },
    {
        action: ItemAction.CLONE,
        text: 'Clone'
    },
    {
        action: ItemAction.DELETE,
        text: 'Remove'
    },
    {
        action: ItemAction.ADD_COMMENT,
        text: 'Comments...'
    },
    {
        action: ItemAction.SAVE_AS_TEMPLATE,
        text: 'Save as template...'
    }
]
